export default "__VITE_ASSET__BysmqfRB__"